import { COMMON_LAYOUT_TYPE } from "../../ListPresentation/components/Testimonials/Constants";
import { COLOR_DIFF_LAYOUT, FILTER_CUSTOM_CLASS, FILTER_CUSTOM_CLASS_2, SIZE } from "../constant";
import Layout1 from "./FilterLayouts/Layout1";
import Layout2 from "./FilterLayouts/Layout2";
import RenderViewMoreAndLess from "./RenderViewMoreAndLess";

function RenderSizeFilters(props) {
  const { data, config, filterName } = props;
  const { sortAndFilter: { appearances: { size = '' } = {}} = {} } = config;
  const layout_desktop = config?.sortAndFilter?.layout_desktop;

  function renderSizeFilterAccToLayout(item) {
    switch (size) {
      case COMMON_LAYOUT_TYPE.ONE:
        return <Layout1 filterData={item} type={SIZE} isSelect={false} filterName={filterName} />
      case COMMON_LAYOUT_TYPE.TWO:
        return <Layout2 filterData={item} type={SIZE} isSelect={false} filterName={filterName} />

    }
  }

  return (
    <RenderViewMoreAndLess
      isLayout2 = {layout_desktop === COMMON_LAYOUT_TYPE.TWO}
      data={data}
      childComponent={renderSizeFilterAccToLayout}
      customClass={COLOR_DIFF_LAYOUT?.includes(size) ? FILTER_CUSTOM_CLASS_2 : FILTER_CUSTOM_CLASS}
    />
  )
}

export default RenderSizeFilters